if (!customElements.get('modal-button')) {
    customElements.define('modal-button', class ModalButton extends HTMLElement {
        constructor() {
            super();
            this.button = this.querySelector('button')
            this.content = this.querySelector('template');
            if (this.content != undefined && this.dataset.remain != "true") {
              document.body.appendChild(this.content.content.cloneNode(true));
              this.content.remove();
            }
            this.target = this.button.getAttribute('target');
            this.target_element = document.getElementById(`${this.target}`);
            this.close_element = document.querySelectorAll(`[action="close"][target="${this.target}"]`);
            this.action = this.button.getAttribute('action');
            this.type = this.button.getAttribute('type');
            this.close_listener = this.closeEsc.bind(this);
            this.customEvent = this.dataset.customEvent;
            this.initiated = false;
            this.init();
        }
        init() {
            this.button.addEventListener('click', this.toggle.bind(this));
            this.button.addEventListener('keydown', this.toggle.bind(this));
            this.close_element.forEach((button) => {
                button.addEventListener('click', this.close.bind(this));
            });
            this.initTargetListeners();
        }
        initTargetListeners() {
            this.target_element.addEventListener('click', (event)=> { //target element is modal backdrop
                if (event.currentTarget == event.target) {
                    this.close();
                }
            })
            document.addEventListener('keydown', this.close_listener);
            this.close_listener = this.target_element.addEventListener('keydown', this.closeEsc.bind(this));
        }
        toggle(event) {
            event.preventDefault();
          if  (event.key != undefined && event.key !== "Enter") {
              return
          }
          if (event.key != undefined && event.key === "Enter") {
            event.preventDefault();
          }
          if (this.action == "toggle") {
              if (this.target_element.classList.contains('modal-show')) {
                  this.close();
              } else {
                  this.open();
              }
          } else {
              this.open();
          }
        }
        open() {
          document.querySelector('body').classList.add('modal-open');
          this.target_element.classList.add('modal-show');
          if (this.customEvent == "AddOnClose") {
            let defaultButton = this.target_element.querySelector('.ajax-submit');
            defaultButton.classList.add('bandpicker__atc');
          }
          if (!this.initiated) {
            this.initiated = true;
            this.querySelectorAll("img").forEach((image) => {
                image.setAttribute("loading", "eager");
                image.setAttribute("fetch", "high");
                image.setAttribute("sizes", `${image.clientWidth}px`);
            })
          }
        }
        close() {
            document.querySelector('body').classList.remove('modal-open');
            this.target_element.classList.remove('modal-show');
            if (this.customEvent == "AddOnClose") {
                let defaultButton = document.querySelector('.bandpicker__cta-container').querySelector('.ajax-submit');
                document.querySelector('rm-slider').classList.remove("side");
                document.querySelector('rm-slider').classList.remove("side-animation");
                defaultButton.classList.remove('bandpicker__atc');
                defaultButton.click();
            }
        }
        
        closeEsc(event) {
          if (event.key === undefined) return
          if  (event.key != undefined && event.key !== "Escape") {
              return
          }
          this.close();
          if (this.type == "template") {
              document.removeEventListener('click', this.close_listener);
          }
        }
        focusTrap() {
            let interactable_elements = this.target_element.querySelectorAll('a,button');
            if (interactable_elements.length > 0) {
                interactable_elements[interactable_elements.length - 1].addEventListener('keydown', (event)=> {
                    if (event.key == "Tab") {
                        event.preventDefault();
                        interactable_elements[0].focus();
                    }
                })
            }
        }
    })
}